import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 8.68V3.5a1 1 0 1 0-2 0v5.18a3 3 0 0 0 0 5.64v7.18a1 1 0 0 0 2 0v-7.18a3 3 0 0 0 0-5.64Zm-1 3.82a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-6 2.18V3.5a1 1 0 1 0-2 0v11.18a3 3 0 0 0 0 5.64v1.18a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64Zm-1 3.82a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6.68V3.5a1 1 0 1 0-2 0v3.18a3 3 0 0 0 0 5.64v9.18a1 1 0 1 0 2 0v-9.18a3 3 0 0 0 0-5.64ZM5 10.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" }, null, -1)
  ])))
}
export default { render: render }